module.exports = __webpack_public_path__ + "static/cad-designs16-3485e742fa66581be32a6cce842f3205.png";